export default __webpack_public_path__ + "static/media/camera.cd0ce497.svg";